import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import QuestionsStep from "./QuestionsStep";
import DiagnosticFeeStep from "./DiagnosticFeeStep";
import AdditionalInfoStep from "./AdditionalInfoStep";
import MaintenanceQuestion from "./MaintenanceQuestion";

export default function Description(props) {
  const {
    _handleNext,
    _handleBack,
    clickMode,
    descriptionActiveStep,
    setIsNextdisabled,
    setNextHide,
    setActiveStepColor,
    _handleDescriptionSteps,
  } = props;

  const { values } = useFormikContext();
  const { questionsData, subQuestionData, selectedData } = values;
  const [isChecked, setIschecked] = useState(false);

  useEffect(() => {
    setActiveStepColor("#FFFFFF");
  }, []);

  const _handleCaseForZero = (step) => {
    switch (step) {
      case 0:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  const _handleCaseForOne = (step) => {
    switch (step) {
      case 0:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={questionsData[step]}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 2:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  const _handleCaseForTwo = (step) => {
    switch (step) {
      case 0:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={questionsData[step]}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={questionsData[step]}
            setIschecked={setIschecked}
          />
        );
      case 2:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 3:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  const _handleCaseForThree = (step) => {
    switch (step) {
      case 0:
        return (
          <QuestionsStep
            questionsData={questionsData[step]}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <QuestionsStep
            questionsData={questionsData[step]}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      case 2:
        return (
          <QuestionsStep
            questionsData={questionsData[step]}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      case 3:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 4:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  const _handleMaintenanceTwoSteps = (step) => {
    switch (step) {
      case 0:
        return (
          <MaintenanceQuestion
            setIsNextdisabled={setIsNextdisabled}
            questionsData={questionsData[step]}
            _handleDescriptionSteps={_handleDescriptionSteps}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={subQuestionData[step]} // we are not including MaintenanceQuestion step questions data in that array that's why we did -1
            setIschecked={setIschecked}
          />
        );
      case 2:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 3:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  const _handleMaintenanceThreeSteps = (step) => {
    switch (step) {
      case 0:
        return (
          <MaintenanceQuestion
            setIsNextdisabled={setIsNextdisabled}
            questionsData={questionsData[step]}
            _handleDescriptionSteps={_handleDescriptionSteps}
            setIschecked={setIschecked}
          />
        );
      case 1:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={subQuestionData[step]} // we are not including MaintenanceQuestion step questions data in that array that's why we did -1
            setIschecked={setIschecked}
          />
        );
      case 2:
        return (
          <QuestionsStep
            setIsNextdisabled={setIsNextdisabled}
            questionsData={subQuestionData[step]} // we are not including MaintenanceQuestion step questions data in that array that's why we did -1
            setIschecked={setIschecked}
          />
        );
      case 3:
        return (
          <DiagnosticFeeStep
            _handleNext={_handleNext}
            _handleBack={_handleBack}
            clickMode={clickMode}
            setIsNextdisabled={setIsNextdisabled}
            isChecked={isChecked}
            setIschecked={setIschecked}
          />
        );
      case 4:
        return (
          <AdditionalInfoStep
            _handleNext={_handleNext}
            setIsNextdisabled={setIsNextdisabled}
            setIschecked={setIschecked}
          />
        );
      default:
        return <div>Not Found</div>;
    }
  };

  function _renderStepContent(step) {
    if (
      (selectedData?.serviceCategory === "Heating Tune-Up" ||
        selectedData?.serviceCategory === "Cooling Tune-Up") &&
      selectedData?.serviceType === "Maintenance"
    ) {
      if (subQuestionData?.length === 3) {
        return _handleMaintenanceThreeSteps(step);
      } else {
        return _handleMaintenanceTwoSteps(step);
      }
      // handle case if 5th or 6th questions to ask
    } else {
      if (questionsData?.length === 1) {
        return _handleCaseForOne(step); // handle case if 1st or 2nd questions to ask
      } else if (questionsData?.length === 2) {
        return _handleCaseForTwo(step); // handle case if 3rd or 4th questions to ask
      } else if (questionsData?.length === 3) {
        return _handleCaseForThree(step); // handle case if 5th or 6th questions to ask
      } else {
        return _handleCaseForZero(step);
      }
    }
  }

  return (
    <React.Fragment>{_renderStepContent(descriptionActiveStep)}</React.Fragment>
  );
}
